import { useState, useEffect, useCallback } from 'react';

import { useNavigate, Link } from 'react-router-dom';

import { ArrowLeft, Save, X, Upload } from 'lucide-react';

import { Button } from '../components/ui/button';

import { Input } from '../components/ui/input';

import { Label } from '../components/ui/label';

import { Textarea } from '../components/ui/textarea';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

import { ImageDropzone } from '../components/ImageDropzone';

import { toast } from 'sonner';

import { propertyTypes } from '../data/mockData';

import { listingService, storageService } from '../lib/databaseService';



export default function CreateListing({ user, listings, onUpdateListings, onRefreshListings, agencies = [] }) {

  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [images, setImages] = useaState([]);

  const safePropertyTypes = Array.isArray(propertyTypes) ? propertyTypes : [];

  

  // Güvenli array kontrolü

  const safeAgencies = Array.isArray(agencies) ? agencies : [];

  const userAgency = user?.agencyId ? safeAgencies.find(a => a && a.id === user.agencyId) : null;

  const isAgent = user?.isAgent === true && !!userAgency;

  const isAdmin = user?.isAdmin === true;

  

  // Admin olmayanlar üçün gündəlik və kompleks kateqoriyalarını blokla

  const isRestrictedCategory = useCallback((category) => {

    return (category === 'daily' || category === 'complex') && !isAdmin;

  }, [isAdmin]);

   

  const [form, setForm] = useState({

    category: isAdmin ? 'sale' : 'sale', // Admin olmayanlar üçün default 'sale'

    type: '',

    rooms: '',

    area: '',

    floor: '',

    totalFloors: '',

    price: '',

    location: '',

    description: '',

    phone: user?.phone || '',

    tamir_status: '', // 'təmirli', 'təmirsiz' və ya boş

    ipoteka: false,

    cixaris: false,

    video_url: '' // YouTube linki və ya Cloudinary video URL

  });

  

  const [videoFile, setVideoFile] = useState(null);

  const [isUploadingVideo, setIsUploadingVideo] = useState(false);



  // Admin olmayanlar üçün qadağan olunmuş kateqoriyaları blokla

  useEffect(() => {

    if (isRestrictedCategory(form.category)) {

      toast.error('Bu kateqoriyaya elan yerləşdirmək üçün admin səlahiyyəti lazımdır');

      setForm(prev => ({ ...prev, category: 'sale' }));

    }

  }, [form.category, isAdmin, isRestrictedCategory]);



  // Drag and Drop State

  const [draggedIndex, setDraggedIndex] = useState(null);

  const [dragOverIndex, setDragOverIndex] = useState(null);



  // --- Drag and Drop Handlers (Pure HTML5/React) ---

  

  const handleDragStart = (e, index) => {

    setDraggedIndex(index);

    setDragOverIndex(index);

    e.dataTransfer.effectAllowed = "move";

    e.dataTransfer.setData('text/html', e.target.outerHTML);

    // Make dragged element semi-transparent

    e.target.style.opacity = '0.5';

  };



  const handleDragEnter = (e, index) => {

    e.preventDefault();

    e.stopPropagation();

    

    if (draggedIndex === null || draggedIndex === index) {

      setDragOverIndex(index);

      return;

    }



    setDragOverIndex(index);



    // Swap items in the array

    const newImages = [...images];

    const draggedItem = newImages[draggedIndex];

    

    // Remove dragged item from its position

    newImages.splice(draggedIndex, 1);

    // Insert at new position

    newImages.splice(index, 0, draggedItem);

    

    // Update state

    setImages(newImages);

    setDraggedIndex(index);

  };



  const handleDragOver = (e) => {

    e.preventDefault();

    e.stopPropagation();

    e.dataTransfer.dropEffect = "move";

  };



  const handleDragLeave = (e) => {

    e.preventDefault();

    e.stopPropagation();

  };



  const handleDragEnd = (e) => {

    // Restore opacity

    e.target.style.opacity = '1';

    // Reset drag state

    setDraggedIndex(null);

    setDragOverIndex(null);

  };



  const handleDrop = (e) => {

    e.preventDefault();

    e.stopPropagation();

    setDraggedIndex(null);

    setDragOverIndex(null);

  };



  const removeImage = (indexToRemove) => {

    setImages(images.filter((_, index) => index !== indexToRemove));

  };



  const handleSubmit = async (e) => {

    e.preventDefault();

     

    if (!form.type || !form.price || !form.location) {

      toast.error('Bütün zəruri sahələri doldurun');

      return;

    }



    // Admin yoxlaması

    if (isRestrictedCategory(form.category)) {

      toast.error('Bu kateqoriyaya elan yerləşdirmək üçün admin səlahiyyəti lazımdır');

      return;

    }



    setIsSubmitting(true);



    try {

          const validImageUrls = Array.isArray(images)

        ? images

            .filter((img) => img && typeof img.publicUrl === 'string' && img.publicUrl)

            .map((img) => img.publicUrl)

        : [];



      const ownerType = isAgent ? 'agency' : isAdmin ? 'admin' : 'sahibinden';

      const agencyId = isAgent && userAgency ? userAgency.id : null;

      const agencyName = isAgent && userAgency ? userAgency.name : null;

      

      const listingData = {

        title: `${form.type} - ${form.location}`,

        description: form.description || null,

        images: validImageUrls,

        category: form.category,

        type: form.type,

        price: form.price,

        currency: 'AZN',

        location: form.location,

        address: form.location,

        rooms: form.rooms || null,

        area: form.area || null,

        floor: form.floor || null,

        total_floors: form.totalFloors || null,

        phone: form.phone || user?.phone || null,

        video_url: form.video_url || null,

        tamir_status: form.tamir_status || null,

        ipoteka: form.ipoteka || false,

        cixaris: form.cixaris || false,

        user_id: user?.id || null, 

        agency_id: agencyId,

        complex_id: null,

        is_vip: false,

        is_agency: isAgent,

        is_active: isAdmin ? true : false, // Admin elanları avtomatik aktiv

        amenities: []

      };



      const insertedListing = await listingService.create(listingData);

      

      if (onRefreshListings) {

        await onRefreshListings();

      }



      toast.success('Elan uğurla əlavə edildi!');

      

      // Admin isə admin panelinə, digərləri ana səhifəyə

      if (isAdmin) {

        navigate('/admin/dashboard');

      } else {

        navigate('/');

      }

      

    } catch (error) {

      console.error('Elan yaratma xətası:', error);

      toast.error(`Xəta: ${error.message || 'Elan əlavə edilə bilmədi'}`);

    } finally {

      setIsSubmitting(false);

    }

  };



  return (

    <div className="min-h-screen bg-gray-50" data-testid="create-listing-page">

      <header className="sticky top-0 z-50 bg-white border-b">

        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">

          <Link to="/" className="flex items-center gap-2 text-gray-600 hover:text-[#B91C1C]">

            <ArrowLeft size={20} />

            <span>Geri</span>

          </Link>

          <span className="logo-text text-2xl font-semibold text-[#B91C1C]">Mydom</span>

        </div>

      </header>



      <main className="max-w-4xl mx-auto px-4 py-8">

        <h1 className="text-3xl font-bold text-gray-900 logo-text mb-8">Yeni Elan Yerləşdir</h1>

        

        {isAgent && userAgency && (

          <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">

            <p className="text-sm text-blue-800">

              <strong>Agent rejimi:</strong> Elanınız <strong>{userAgency.name}</strong> agentliyinə bağlı olacaq.

            </p>

          </div>

        )}



        <form onSubmit={handleSubmit} className="space-y-8">

          

          {/* FOTOĞRAF YÜKLEME VE SIRALAMA ALANI */}

          <div className="bg-white rounded-xl p-6 border">

            <h2 className="text-lg font-semibold mb-4">Şəkillər</h2>

            

            {/* HATANIN OLDUĞU YER DÜZELTİLDİ: P etiketi kapatıldı */}

            <p className="text-sm text-gray-500 mb-4">

              Şəkilləri yüklədikdən sonra yerini dəyişmək üçün üzərinə basıb sürüşdürə bilərsiniz.

              İlk sırada duran şəkil <strong>əsas şəkil (kapak)</strong> olacaqdır.

            </p>



            {/* Dosya Yükleme Alanı */}

            <ImageDropzone images={images} onImagesChange={setImages} maxFiles={30} />



            {/* Drag and Drop Image Grid */}

            {Array.isArray(images) && images.length > 0 && (

              <div className="mt-6 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-4">

                {images.map((img, index) => (

                  <div

                    key={`img-${index}-${img?.publicUrl || 'no-url'}`}

                    draggable

                    onDragStart={(e) => handleDragStart(e, index)}

                    onDragEnter={(e) => handleDragEnter(e, index)}

                    onDragOver={handleDragOver}

                    onDragLeave={handleDragLeave}

                    onDragEnd={handleDragEnd}

                    onDrop={handleDrop}

                    className={`

                      relative aspect-square rounded-lg overflow-hidden border cursor-move group

                      transition-all duration-200 ease-in-out

                      ${draggedIndex === index 

                        ? 'opacity-50 scale-105 shadow-xl ring-2 ring-[#B91C1C] z-50' 

                        : dragOverIndex === index && draggedIndex !== index

                        ? 'ring-2 ring-blue-400 scale-105 bg-blue-50'

                        : 'hover:shadow-md bg-gray-100'

                      }

                    `}

                  >

                    <img 

                      src={img?.publicUrl || ''} 

                      alt={`Upload ${index + 1}`} 

                      className="w-full h-full object-cover pointer-events-none select-none"

                      draggable="false"

                    />

                    

                    {/* Remove Button */}

                    <button

                      type="button"

                      onClick={() => removeImage(index)}

                      className="absolute top-1 right-1 bg-red-500/90 hover:bg-red-600 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity z-10"

                      aria-label="Remove image"

                    >

                      <X size={14} />

                    </button>



                    {/* Position Label / Cover Image Badge */}

                    <div className="absolute bottom-0 left-0 right-0 bg-black/60 text-white text-xs py-1 text-center pointer-events-none">

                      {index === 0 ? 'Əsas Şəkil' : `${index + 1}. Şəkil`}

                    </div>

                  </div>

                ))}

              </div>

            )}

          </div>



          <div className="bg-white rounded-xl p-6 border">

            <h2 className="text-lg font-semibold mb-4">Əsas Məlumatlar</h2>

            <div className="grid md:grid-cols-2 gap-4">

              <div className="space-y-2">

                <Label>Kateqoriya *</Label>

                <Select 

                  value={form.category} 

                  onValueChange={(v) => {

                    if (isRestrictedCategory(v) && !isAdmin) {

                      toast.error('Bu kateqoriyaya elan yerləşdirmək üçün admin səlahiyyəti lazımdır');

                      return;

                    }

                    setForm({...form, category: v});

                  }}

                >

                  <SelectTrigger><SelectValue /></SelectTrigger>

                  <SelectContent>

                    <SelectItem value="sale">Satış</SelectItem>

                    <SelectItem value="rent">Kirayə (aylıq)</SelectItem>

                    {isAdmin && (

                      <>

                        <SelectItem value="daily">Gündəlik Kirayə</SelectItem>

                        <SelectItem value="complex">Yaşayış Kompleksləri</SelectItem>

                      </>

                    )}

                  </SelectContent>

                </Select>

                {!isAdmin && (

                  <p className="text-xs text-gray-500">

                    Qeyd: Gündəlik kirayə və yaşayış kompleksləri üçün elan yerləşdirmək yalnız adminlər üçün mümkündür

                  </p>

                )}

              </div>

              <div className="space-y-2">

                <Label>Əmlak növü *</Label>

                <Select value={form.type} onValueChange={(v) => setForm({...form, type: v})}>

                  <SelectTrigger><SelectValue placeholder="Seçin" /></SelectTrigger>

                  <SelectContent>

                    {safePropertyTypes.map(t => (

                      <SelectItem key={t.id} value={t.label}>{t.label}</SelectItem>

                    ))}

                  </SelectContent>

                </Select>

              </div>

              <div className="space-y-2">

                <Label>Qiymət (AZN) *</Label>

                <Input type="number" value={form.price} onChange={(e) => setForm({...form, price: e.target.value})} />

              </div>

              <div className="space-y-2">

                <Label>Otaq sayı</Label>

                <Input type="number" value={form.rooms} onChange={(e) => setForm({...form, rooms: e.target.value})} />

              </div>

              <div className="space-y-2">

                <Label>Sahə (m²)</Label>

                <Input type="number" value={form.area} onChange={(e) => setForm({...form, area: e.target.value})} />

              </div>

              <div className="space-y-2">

                <Label>Mərtəbə</Label>

                <div className="flex gap-2">

                  <Input type="number" placeholder="Mərtəbə" value={form.floor} onChange={(e) => setForm({...form, floor: e.target.value})} />

                  <Input type="number" placeholder="Ümumi" value={form.totalFloors} onChange={(e) => setForm({...form, totalFloors: e.target.value})} />

                </div>

              </div>

            </div>

          </div>



          <div className="bg-white rounded-xl p-6 border">

            <h2 className="text-lg font-semibold mb-4">Ünvan və Əlaqə</h2>

            <div className="space-y-4">

              <div className="space-y-2">

                <Label>Ünvan *</Label>

                <Input value={form.location} onChange={(e) => setForm({...form, location: e.target.value})} placeholder="Rayon, küçə, ev nömrəsi" />

              </div>

              <div className="space-y-2">

                <Label>Telefon *</Label>

                <Input 

                  value={form.phone} 

                  onChange={(e) => setForm({...form, phone: e.target.value})} 

                  placeholder={isAgent ? "Şəxsi telefon nömrəniz" : "+994 XX XXX XX XX"} 

                />

                {isAgent && (

                  <p className="text-xs text-gray-500">

                    Bu nömrə elanlarda göstəriləcək. Agentlik telefonu: {userAgency?.phone || 'Məlumat yoxdur'}

                  </p>

                )}

              </div>

            </div>

          </div>



          {/* Xüsusiyyətlər */}

          <div className="bg-white rounded-xl p-6 border">

            <h2 className="text-lg font-semibold mb-4">Əlavə Xüsusiyyətlər</h2>

            <div className="grid md:grid-cols-3 gap-4">

              <div className="space-y-2">

                <Label>Təmir Statusu</Label>

                <Select 

                  value={form.tamir_status || ''} 

                  onValueChange={(v) => setForm({...form, tamir_status: v})}

                >

                  <SelectTrigger>

                    <SelectValue placeholder="Seçin (məcburi deyil)" />

                  </SelectTrigger>

                  <SelectContent>

                    <SelectItem value="">Seçilməyib</SelectItem>

                    <SelectItem value="təmirli">🏠 Təmirli</SelectItem>

                    <SelectItem value="təmirsiz">🏚️ Təmirsiz</SelectItem>

                  </SelectContent>

                </Select>

              </div>

              <div className="space-y-2 flex items-end">

                <div className="flex items-center space-x-2 h-10">

                  <input

                    type="checkbox"

                    id="ipoteka"

                    checked={form.ipoteka}

                    onChange={(e) => setForm({...form, ipoteka: e.target.checked})}

                    className="w-4 h-4 text-[#B91C1C] border-gray-300 rounded focus:ring-[#B91C1C]"

                  />

                  <Label htmlFor="ipoteka" className="text-base font-medium cursor-pointer">

                    🏦 İpoteka var

                  </Label>

                </div>

              </div>

              <div className="space-y-2 flex items-end">

                <div className="flex items-center space-x-2 h-10">

                  <input

                    type="checkbox"

                    id="cixaris"

                    checked={form.cixaris}

                    onChange={(e) => setForm({...form, cixaris: e.target.checked})}

                    className="w-4 h-4 text-[#B91C1C] border-gray-300 rounded focus:ring-[#B91C1C]"

                  />

                  <Label htmlFor="cixaris" className="text-base font-medium cursor-pointer">

                    📄 Çıxarış (Kupça) var

                  </Label>

                </div>

              </div>

            </div>

          </div>



          {/* Video Yükləmə */}

          <div className="bg-white rounded-xl p-6 border">

            <h2 className="text-lg font-semibold mb-4">Video (İstəyə bağlı)</h2>

            <div className="space-y-4">

              <div className="space-y-2">

                <Label>YouTube Linki</Label>

                <Input

                  type="url"

                  value={form.video_url}

                  onChange={(e) => setForm({...form, video_url: e.target.value})}

                  placeholder="https://www.youtube.com/watch?v=... və ya https://youtu.be/..."

                />

                <p className="text-xs text-gray-500">

                  YouTube video linki yapışdırın və ya aşağıdakı düymə ilə fayl yükləyin

                </p>

              </div>

              

              <div className="relative">

                <div className="absolute inset-0 flex items-center">

                  <span className="w-full border-t" />

                </div>

                <div className="relative flex justify-center text-xs uppercase">

                  <span className="bg-white px-2 text-gray-500">və ya</span>

                </div>

              </div>



              <div className="space-y-2">

                <Label>Video Faylı Yüklə</Label>

                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-[#B91C1C] transition-colors">

                  <input

                    type="file"

                    id="video-upload"

                    accept="video/*"

                    onChange={async (e) => {

                      const file = e.target.files[0];

                      if (!file) return;

                      

                      if (file.size > 100 * 1024 * 1024) { // 100MB limit

                        toast.error('Video ölçüsü 100MB-dan çox ola bilməz');

                        return;

                      }

                      

                      setIsUploadingVideo(true);

                      try {

                        const result = await storageService.uploadVideo(file);

                        setForm({...form, video_url: result.publicUrl});

                        setVideoFile(file);

                        toast.success('Video uğurla yükləndi');

                      } catch (error) {

                        console.error('Video yükləmə xətası:', error);

                        toast.error('Video yüklənmədi. Zəhmət olmasa yenidən cəhd edin.');

                      } finally {

                        setIsUploadingVideo(false);

                      }

                    }}

                    className="hidden"

                    disabled={isUploadingVideo || !!form.video_url}

                  />

                  <label

                    htmlFor="video-upload"

                    className={`cursor-pointer ${(isUploadingVideo || !!form.video_url) ? 'opacity-50 cursor-not-allowed' : ''}`}

                  >

                    {isUploadingVideo ? (

                      <div className="flex flex-col items-center">

                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#B91C1C] mb-2"></div>

                        <p className="text-gray-600">Yüklənir...</p>

                      </div>

                    ) : form.video_url ? (

                      <div className="flex flex-col items-center">

                        <p className="text-green-600 font-medium">Video yükləndi</p>

                        <button

                          type="button"

                          onClick={(e) => {

                            e.stopPropagation();

                            setForm({...form, video_url: ''});

                            setVideoFile(null);

                          }}

                          className="mt-2 text-sm text-red-600 hover:text-red-700"

                        >

                          Sil

                        </button>

                      </div>

                    ) : (

                      <div className="flex flex-col items-center">

                        <Upload size={32} className="text-gray-400 mb-2" />

                        <p className="text-gray-600">Video faylı seçin</p>

                        <p className="text-xs text-gray-400 mt-1">MP4, MOV, AVI (maksimum 100MB)</p>

                      </div>

                    )}

                  </label>

                </div>

              </div>

            </div>

          </div>



          <div className="bg-white rounded-xl p-6 border">

            <h2 className="text-lg font-semibold mb-4">Təsvir</h2>

            <Textarea

              value={form.description}

              onChange={(e) => setForm({...form, description: e.target.value})}

              placeholder="Əmlak haqqında ətraflı məlumat yazın..."

              rows={6}

            />

          </div>



          <div className="flex justify-end gap-4">

            <Button type="button" variant="outline" onClick={() => navigate('/')}>Ləğv et</Button>

            <Button type="submit" className="bg-[#B91C1C] hover:bg-[#991B1B]" disabled={isSubmitting}>

              <Save size={18} className="mr-2" />

              {isSubmitting ? 'Yerləşdirilir...' : 'Elanı Yerləşdir'}

            </Button>

          </div>

        </form>

      </main>

    </div>

  );

}
